module.exports = __webpack_public_path__ + "static/media/star-icon-active.8bc730e7.svg";